var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxRussian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "px-russian") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Driver-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-Language-selection-\\u2013-EN-initial-\\u2013-with-damage-\\u2013-Rewe",
    transform: "translate(-16.000000, -504.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "px-russian",
    transform: "translate(16.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3185024,8 C23.7612588,9.24219341 24,10.676613 24,12.0697674 C24,13.4629219 23.7612588,14.800005 23.3185024,16.0465116 L0.681497558,16.0465116 C0.238741183,14.800005 0,13.4629219 0,12.0697674 C0,10.676613 0.238741183,9.24650658 0.681497558,8 L23.3185024,8 Z",
    id: "Path",
    fill: "#0039A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C17.1968601,0 21.6198976,3.29205644 23.2823722,7.89777333 C23.2890682,7.91632374 23.3106502,7.98140709 23.3172564,8 L0.682830811,8 C0.690020546,7.97975757 0.712106982,7.91302871 0.719402733,7.89283685 C1.32337565,6.2212703 2.29004296,4.72359788 3.52325581,3.49556461 C5.69444643,1.33349317 8.68904266,0 12,0 Z",
    id: "Path",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.697674419,16.0465116 L23.3023256,16.0465116 C22.6998239,17.7415881 21.7245513,19.2598244 20.4718678,20.506331 C18.3045954,22.6629168 15.3050904,24 11.9978327,24 C8.6862405,24 5.69107004,22.6629168 3.52379763,20.506331 C2.27544873,19.2598244 1.30017615,17.7372749 0.697674419,16.0465116 Z",
    id: "Path",
    fill: "#D52B1E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxRussian);
export default __webpack_public_path__ + "static/media/px-russian.9473674c1175a1c3b1e629c72a9e5674.svg";
export { ForwardRef as ReactComponent };